import foldCase from 'fold-case';
import { nfkd } from 'unorm';

export const normalize = (string) => foldCase(nfkd(string));

export const toLowerCase = (string) => string.toLowerCase().trim();
